import { FormattedMessage } from 'react-intl';

import './ErrorToast.sass';

const ErrorToast = ({ errorText, closeError }: { errorText: string; closeError: () => void }) => {
	return (
		<dialog id="error-toast" open={!!errorText} onClick={closeError}>
			<span className="icon icon-cross" />
			{errorText !== null && (
				<span>
					<FormattedMessage id={`${errorText}`} />
				</span>
			)}
		</dialog>
	);
};

export default ErrorToast;
